import { render, staticRenderFns } from "./ClientReview.vue?vue&type=template&id=b0b9cd58&scoped=true&"
import script from "./ClientReview.vue?vue&type=script&lang=js&"
export * from "./ClientReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b9cd58",
  null
  
)

export default component.exports